import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/images/logo.svg'
import _imports_1 from '../assets/images/illustration-dashboard.png'


const _hoisted_1 = { class: "ping-coming-soon-page" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo"
  }),
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "subtle" }, "We are launching"),
    /*#__PURE__*/_createTextVNode(" soon!")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "content" }, "Subscribe and get notified")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "validation-error" }, "Please provide a valid email address", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Notify Me", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Dashboard Illustration"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "social" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-facebook-f" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-twitter" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-instagram" })
  ])
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("footer", null, " © Copyright Ping. All rights reserved. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["control", {'invalid': !_ctx.isEmailValid}])
        }, [
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
            type: "text",
            placeholder: "Your email address..."
          }, null, 512), [
            [_vModelText, _ctx.email]
          ]),
          _hoisted_4
        ], 2),
        _hoisted_5
      ], 32),
      _hoisted_6,
      _hoisted_7,
      _hoisted_8
    ])
  ]))
}